import { useState } from "react";
import type { Rol } from "@/lib/api";
import { estaInstalada } from "@/lib/navegadorPush";
import { esIos } from "@/lib/push";

const CLAVE_CARTEL = "matsu.cartel-instalar";

function cartelCerrado(): boolean {
  try {
    return localStorage.getItem(CLAVE_CARTEL) === "cerrado";
  } catch {
    return false;
  }
}

/** El cartel "Instalá la app" del Inicio: en iPhone sin instalar, para quien recibe avisos (no el admin), hasta que lo cierre. */
export function useCartelInstalar(rol: Rol) {
  const [cerrado, setCerrado] = useState(cartelCerrado);
  const visible = rol !== "admin" && esIos(navigator.userAgent) && !estaInstalada() && !cerrado;
  const cerrar = () => {
    setCerrado(true);
    try {
      localStorage.setItem(CLAVE_CARTEL, "cerrado");
    } catch {
      /* sin storage: se cierra sólo por esta vez */
    }
  };
  return { visible, cerrar };
}
